module.exports = __webpack_public_path__ + "6a9e85ac9247f5848db957b873c62e0c.ttf";